import { httpsCallable } from "firebase/functions";
import { doc, getDocFromServer } from "firebase/firestore";
import { auth, db, functions } from "../firebase";
import type { LocaleCode } from "../localization/types";

export interface NotificationLocaleService {
  save(userId: string, locale: LocaleCode): Promise<void>;
}

export const notificationLocaleService: NotificationLocaleService = {
  async save(userId, locale) {
    if (auth.currentUser?.uid !== userId) return;
    // Use a fresh server revision, including after timeouts. The callable rejects
    // a delayed write if a newer save has advanced it in the meantime.
    const profile = await getDocFromServer(doc(db, "users", userId));
    if (auth.currentUser?.uid !== userId) return;
    await httpsCallable(functions, "updateNotificationLocale", { timeout: 10000 })({
      expectedUserId: userId,
      locale,
      expectedRevision: profile.data()?.notificationLocaleRevision ?? null,
    });
  },
};
